export default "__VITE_ASSET__BohXeBYD__"